import React, { useEffect, useContext } from "react";
import { MapContext } from "./Map";
export default ({ level = "province", subdistrict = 0, name }) => {
  const map = useContext(MapContext);
  useEffect(() => {
    if (!map || !name) return;
    let polygon;
    var districtSearch = new window.AMap.DistrictSearch({
      level,
      subdistrict,
      extensions: "all",
    });
    const handle = (result) => {
      let bounds = result.districtList[0].boundaries;
      if (bounds) {
        for (let i = 0, l = bounds.length; i < l; i++) {
          polygon = new window.AMap.Polygon({
            map,
            strokeWeight: 1,
            path: bounds[i],
            fillOpacity: 0,
            // fillColor: "#256edc",
            strokeColor: "#189CFF",
            strokeWeight: 3,
          });
        }
      }
    };
    districtSearch.search(name, (status, result) => {
      handle(result);
    });
    return () => {
      polygon && polygon.setMap(null);
    };
  }, [map, name]);
  if (!window.AMap) return null;
  return <div className="MapDistrict"></div>;
};
